import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-textarea',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="form-section">
      <label [for]="id" [class.required-field]="required">{{ label }}</label>
      <div *ngIf="readonly" class="readonly-value readonly-textarea">
        <div class="textarea-content">{{ value || '-' }}</div>
      </div>
      <textarea
        *ngIf="!readonly"
        [id]="id"
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        [name]="name"
        [placeholder]="placeholder"
        (blur)="onTouched()"
        class="form-input"
      ></textarea>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormTextareaComponent),
      multi: true
    }
  ],
  styleUrls: ['total-component.scss']
})
export class FormTextareaComponent implements ControlValueAccessor {
  @Input() label: string = ''; // 標籤
  @Input() id: string = ''; // id 用於對應 label
  @Input() name: string = ''; // name 用於表單提交
  @Input() placeholder: string = ''; // 佔位符
  @Input() required: boolean = false; // 是否必填
  @Input() readonly: boolean = false; // 新增：只讀模式

  value: string = ''; // 綁定的值

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  // ControlValueAccessor 實作
  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // 可以加入 disabled 狀態處理
  }
}
